import { FunctionComponent } from 'react';
import { Box, Button, Modal, SpaceBetween, Header } from '@amzn/awsui-components-react';
import { Order } from '@amzn/ito-client';
import { getString } from 'common/ui-string-labels/ui-strings-utils';

export interface CompleteBulkOrderModalProps {
    visible: boolean;
    orders: Order[];
    onDismiss: () => void;
    onConfirm: () => void;
}

export const CompleteBulkOrderModal: FunctionComponent<CompleteBulkOrderModalProps> = ({
    visible, orders, onDismiss, onConfirm,
}) => {
    return (
        <Modal
            data-testid="complete-bulk-order-modal"
            visible={visible}
            onDismiss={onDismiss}
            header={<Header variant="h2">{getString('bulkOrders.submittedOrders.completeModalTitle')}</Header>}
            footer={
                <Box float="right">
                    <SpaceBetween direction="horizontal" size="xs">
                        <Button data-testid="complete-bulk-order-cancel" variant="link" onClick={onDismiss}>{getString('common.cancel')}</Button>
                        <Button data-testid="complete-bulk-order-confirm" variant="primary" onClick={onConfirm}>
                            {getString('bulkOrders.submittedOrders.completeButton')}
                        </Button>
                    </SpaceBetween>
                </Box>
            }
        >
            <SpaceBetween size="m">
                {orders.length === 1 ? (
                    <Box>
                        <b>{(orders[0].items?.[0]?.itemInformation as any)?.name || 'Order'}</b> — {orders[0].items?.[0]?.quantity || 1} {getString('bulkOrders.submittedOrders.seats')}
                    </Box>
                ) : (
                    <Box>
                        {orders.length} {getString('bulkOrders.submittedOrders.ordersSelected')}
                    </Box>
                )}
            </SpaceBetween>
        </Modal>
    );
};
